import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import CButton from "./CButton";
import { useEffect, useState } from "react";

const StartOfMonthPopup = ({ handleNext }) => {
  const [open, setOpen] = useState(false);
  const userDetails =
    JSON.parse(localStorage.getItem("user")) ||
    JSON.parse(sessionStorage.getItem("user"));

  useEffect(() => {
    if (userDetails.startOfMonthNotification) {
      setOpen(true);
    }
  }, [userDetails.startOfMonthNotification]);

  const handleStartOfMonthNotification = () => {
    const updatedUserDetails = {
      ...userDetails,
      startOfMonthNotification: false,
    };
    localStorage.setItem("user", JSON.stringify(updatedUserDetails));
    handleNext();
    setOpen(false);
  };

  return (
    <Dialog open={open} className="custom-dialog">
      {/* <DialogTitle>Session Expiring</DialogTitle> */}
      <DialogContent>
        <DialogContentText sx={{ pt: 4, textAlign: "center" }}>
          {userDetails.startOfMonthNotificationMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{ p: 3, pt: 1, display: "flex", justifyContent: "center" }}
      >
        <CButton
          onClick={handleStartOfMonthNotification}
          className="btn-primary"
        >
          Okay
        </CButton>
      </DialogActions>
    </Dialog>
  );
};

export default StartOfMonthPopup;
